<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <div class="login-header">
                        <img class="login-logo" src="../../../src/assets/img/witcloud-logo.png" alt="Witcloud Logo ">
                        <p class="messageWelcome">Do you forget your password? No problem!</p>
                        <!-- <p>Log in to get going</p> -->
                    </div>
                    <b-card-group>
                        <b-card no-body class="p-4 login-box">
                            <b-card-body>
                                <!-- <h1>Forgot password</h1> -->
                                <p class="login-headline">Please enter email associated with your account, we will send you verification: </p>

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="icon-user"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="email" v-model="$v.forgotPasswordForm.email.$model" class="form-control" placeholder="You e-mail adress">
                                    </b-form-input>
                                </b-input-group>

                                <p v-if="emailSent" class="text-success">Verification email sent, check your mailbox</p>
                                <Feedback :state="validateRef('forgotPasswordForm.email')" invalid="This field is required and must be a valid email"></Feedback>
                                <Feedback :state="forgotError.state" :invalid="forgotError.message"></Feedback>

                                <b-row>
                                    <b-col cols="6" class="login-button-box">
                                        <b-button :disabled="$v.forgotPasswordForm.$invalid" @click="forgotPassword" variant="primary" class="px-4 login-button">Submit</b-button>
                                    </b-col>
                                </b-row>

                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {validationMixin} from 'vuelidate'

import {required, email} from 'vuelidate/lib/validators'

import Feedback from '@/components/Feedback'

export default {
    data() {
        return {
            forgotPasswordForm: {
                email: null,
            },
            emailSent: false,
            forgotError: {
                state: true,
                message: '',
            },
        }
    },
    mixins: [validationMixin],
    validations: {
        forgotPasswordForm: {
            email: {
                required,
                email,
            },
        },
    },
    methods: {
        forgotPassword() {
            const data = {email: this.forgotPasswordForm.email}
            this.axios
                .post(`${process.env.VUE_APP_NODE_API_HOST}/password/forgot`, data)
                .then(response => {
                    this.emailSent = true
                    this.forgotError.state = true
                })
                .catch(exception => {
                    this.forgotError.state = false
                    this.forgotError.message = exception.response.data.additionalInfo
                })
        },
        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },
    },
    components: {
        Feedback,
    },
}
</script>